module.exports = __webpack_public_path__ + "img/sup_register_3.2b03d583.png";